// Default Components
const DefaultContainer = () => import('@/containers/DefaultContainer')
const Login = () => import('@/modules/auth/views/Login')
const ForgotPassword = () => import('@/modules/auth/views/ForgotPassword')
const ResetPassword = () => import('@/modules/auth/views/ResetPassword')
const AllowedIpList = () => import('@/modules/auth/views/AllowedIpList')
import { h } from "vue";
import { RouterView } from 'vue-router'

const routes = [
    {
        path: '/',
        redirect: '/login',
        name: 'test',
        component: {
            render() { return h(RouterView) }
        },
        children: [
            {
                path: 'login',
                name: 'Login',
                component: Login,
                meta: {
                    checkPermission: false,
                }
            },
        ]
    },
    {
        path: '/forgot-password',
        name: 'ForgotPassword',
        component: ForgotPassword,
        meta: {
            requiresAuth: false,
        }
    },
    {
        path: '/reset-password/:code',
        name: 'ResetPassword',
        component: ResetPassword,
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/allowed-ips',
        component: DefaultContainer,
        meta: {
            requiresAuth: true,
        },
        children: [
			{
                path: '',
				name: 'AllowedIpList',
				component: AllowedIpList,
                meta: {
                    requiresAuth: true,
                },
			}
		]
    }
];

export default routes;
